import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Chip } from '@mui/material'
import { SalaryApprovalStatus } from '../../../../features/salary/salarySlice'
import { tone } from '../../../../utils/uiTokens'

const TONE: Record<SalaryApprovalStatus, { id: string; bg: string; color: string }> = {
    PENDING: { id: 'approvalPending', bg: tone.warn.bg, color: tone.warn.text },
    APPROVED: { id: 'approvalApproved', bg: tone.ok.bg, color: tone.ok.text },
    RETURNED: { id: 'approvalReturned', bg: tone.bad.bg, color: tone.bad.text },
}

// Статус бекіту пән басшы; у қайтарылды под чипом комментарий
const ApprovalBadge: React.FC<{ status?: SalaryApprovalStatus | string; comment?: string }> = ({ status, comment }) => {
    const { formatMessage } = useIntl()
    const tone = TONE[(status as SalaryApprovalStatus) || 'PENDING'] ?? TONE.PENDING
    return (
        <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
            <Chip
                size="small"
                label={formatMessage({ id: tone.id })}
                sx={{ fontWeight: 700, fontSize: '11px', backgroundColor: tone.bg, color: tone.color }}
            />
            {status === 'RETURNED' && comment && (
                <Box sx={{ fontSize: '12px', color: tone.color, maxWidth: 260 }}>«{comment}»</Box>
            )}
        </Box>
    )
}

export default ApprovalBadge
